<template>
    <ion-page>
        <ion-header>
            <ion-item color="light" lines="none">
                <SearchBar v-model="search" placeholder="Zoeken">
                </SearchBar>

            </ion-item>
        </ion-header>

        <ion-content color="light">
            <ion-refresher slot="fixed" pull-factor="0.5" pull-min="100" pull-max="200" @ionRefresh="refresh">
                <ion-refresher-content></ion-refresher-content>
            </ion-refresher>

            <Loading v-if="loading"></Loading>

            <template v-else>
                <ion-list :inset="inset" lines="inset" ref="list" class="mt-2">
                    <ion-item v-for="item in filteredItems" :key="item.uuid" v-ripple :detail="false" button
                        @click="open(item)" class="ion-item-clickable">
                        <ion-thumbnail v-if="thumbnail" slot="start">
                            <slot name="thumbnail" v-bind="item"></slot>
                        </ion-thumbnail>
                        <ion-label :class="truncate ? 'no-truncate' : null" class="clickable-label">
                            {{ item.name }}
                        </ion-label>

                        <mdicon slot="end" name="plus-circle-outline" class="color-primary"></mdicon>
                    </ion-item>
                </ion-list>

                <no-data icon="view-module-outline" v-if="filteredItems.length == 0">
                    <template #info>
                        <p class="no-data-title">Geen component gevonden</p>
                        <p class="no-data-subtitle">
                            Er zijn geen componenten gevonden. Vraag de applicatiebeheerder om een component toe te
                            voegen.
                        </p>
                    </template>
                </no-data>
            </template>
        </ion-content>
    </ion-page>
</template>
<script>
import Fuse from "fuse.js";
import { add, filter } from "ionicons/icons";
import { cloudOffline } from "ionicons/icons";
import { VueScreenSizeMixin } from "vue-screen-size";
import NoData from "./NoData.vue";
import { db } from "@/services/db";

import { IonList, IonItem, IonThumbnail, IonLabel, IonRefresher, IonRefresherContent, IonSearchbar } from "@ionic/vue";
import Loading from "@/components/Loading.vue";
import { v4 as uuidv4 } from "uuid";

export default {
    name: "novacheck-list",
    props: [
        "icon",
        "field_name",
        "loading",
        "show_search",
        "can_delete",
        "size",
        "thumbnail",
        "done_loading",
        "item_size",
        "no_created_at",
        "truncate",
        "last_searched_section",
        "parent_uuid",
        "inset",
        "max_items",
        "no_padding",
        "existing_items",
        "is_parent",
    ],
    mixins: [VueScreenSizeMixin],
    components: {
        IonList,
        IonItem,
        IonThumbnail,
        IonLabel,
        IonRefresher,
        IonRefresherContent,
        IonSearchbar,
        Loading,
        NoData,
    },
    data() {
        return {
            components: [],
            cloudOffline,
            search: "",
            filter: filter,
            desc: false,
        };
    },
    emits: ["refresh", "open", "deleteItem", "new"],
    created() {
        this.setup()
    },
    methods: {
        async setup() {
            // if this.is_parent is true, we only show the parent components (parent = true)
            this.components = await db.base_components.toArray();

            // filter out on parent boolean (this.is_parent)
            this.components = this.components.filter((item) => {
                if (this.is_parent) {
                    return item.parent;
                } else {
                    return !item.parent;
                }
            });


            // we add component_uuid to each component
            this.components = this.components.map((component) => {
                return {
                    ...component,
                    component_uuid: component.uuid,
                };
            });

            // sort those bad boys
            this.components.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
        },
        toggleFavorite(item) {
            let all_items = this.$store.getters.getLastSearchedItems;
            let filtered_items = all_items.filter((i) => i.item.id != item.item.id);
            filtered_items.push({ item: item.item, section: item.section, date: new Date(), favorite: !item.favorite });

            this.$store.dispatch("setLastSearchedItems", filtered_items);
        },
        async open(item = null, is_existing = false) {

            // if existing item, we emit and return
            if (is_existing) {
                console.log("existing item", item);
                this.$emit("open", item, true);
                return;
            }

            if (this.last_searched_section && item) {
                var all_items = this.getLastSearchedItems;
                var filtered_items = all_items.filter((i) => i.item.id != item.id);
                var item_to_add = {
                    item: item,
                    section: this.last_searched_section,
                    date: new Date(),
                    favorite: false,
                };

                filtered_items.push(item_to_add);

                // max 5 items. Remove the oldest one if its not a favorite
                if (filtered_items.length > 6) {
                    // find the non favorites
                    let non_favorites = filtered_items.filter((i) => !i.favorite);

                    // remove the oldest
                    let oldest = non_favorites.reduce((oldest, current) => {
                        return oldest.date < current.date ? oldest : current;
                    }, non_favorites[0]);

                    filtered_items = filtered_items.filter((i) => i.item.id != oldest.item.id);
                }
                await this.$store.dispatch("setLastSearchedItems", filtered_items);
            }

            this.$emit("open", item);
        },
        setDesc() {
            this.desc = !this.desc;
        },
        getFirstLetter(name) {
            return name.charAt(0);
        },
        refresh($event) {
            this.$emit("refresh", $event);
            $event.target.complete();
        },
        deleteComponent(item) {
            this.$refs.list.$el.closeSlidingItems();
            this.$emit("deleteItem", item);
        },
        deleteLastSearchedItem(item) {
            let all_items = this.$store.getters.getLastSearchedItems;
            let filtered_items = all_items.filter((i) => i.item.id != item.id);
            this.$store.dispatch("setLastSearchedItems", filtered_items);
        },
    },
    computed: {
        getKeyField() {
            if (!this.components || this.components.length == 0) {
                return "uuid";
            } else if (this.components[0].uuid) {
                return "uuid";
            }

            return "id";
        },
        getFieldName() {
            if (this.field_name) {
                return this.field_name;
            } else {
                return "name";
            }
        },
        filteredItems() {
            let items = this.components;

            if (this.is_parent) {
                items = items.filter(item => item.parent)
            } else {
                items = items.filter(item => !item.parent)
            }

            if (this.search == "") {
                if (this.max_items) {
                    return items.slice(0, this.max_items);
                }
                return items;
            }

            const options = {
                keys: ["name", "remark"],
                threshold: 0.3,
                shouldSort: true,
            };

            const fuse = new Fuse(items, options);

            let search_result = fuse.search(this.search);
            search_result = search_result.map((item) => item.item);

            if (this.max_items) {
                return search_result.slice(0, this.max_items);
            }

            return search_result;
        },
        getLastSearchedItems() {
            let all_items = this.$store.getters.getLastSearchedItems;

            if(!all_items) {
                return [];
            }

            // only with section components
            all_items = all_items.filter((i) => i.section == 'components');

            if (all_items) {
                // Filter items based on whether parent_uuid is present and the item's parent status
                let filtered_items = all_items.filter((item) => {
                    if (this.is_parent) {
                        return item.item.parent;
                    } else {
                        return !item.item.parent;
                    }
                });

                filtered_items.sort((a, b) => {
                    return new Date(b.date) - new Date(a.date);
                });

                // Sorting by favorites - favorites come first
                // This sort is stable, so it will keep the order from the previous sort
                filtered_items.sort((a, b) => {
                    return b.favorite === a.favorite ? 0 : b.favorite ? 1 : -1;
                });

                return filtered_items;
            }


            return [];
        },
    },
};
</script>
<style scoped>
.scroller {
    height: 100%;
}

.ion-item-clickable {
    cursor: pointer;
}

/* Ensure ion-label does not interfere with the click events */
.clickable-label {
    pointer-events: none;
}

/* Ensure no pointer-events for child elements to allow full item click */
.ion-item-clickable ion-thumbnail,
.ion-item-clickable slot {
    pointer-events: none;
}

.list-divider {
    font-size: 13px;
    color: var(--ion-color-medium);
    display: block;
    padding-left: 15px;
    padding-top: 20px;
    padding-bottom: 5px;
}
</style>
